import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { MenuItem, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { branch, compose, renderComponent, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import logo from '../../../images/logo_rev.png';
import { fullName } from '../../../services';
import { sessionActions } from '../../../state/modules/session';
import { currentUserSelector } from '../../../state/modules/user';
import { Icon } from '../../components';

const NavDropdownTitle = () => (
  <button className='btn navbar-btn'>
    <Icon icon='settings' />
  </button>
);

const CloseNav = () => (
  <div className='header-close'>
    <LinkContainer exact className='navbar-btn' to={routes.publisherPortal.dashboard}>
      <button className='btn navbar-btn'>
        <Icon icon='close' />
      </button>
    </LinkContainer>
  </div>
);

const MenuNav = branch(
  ({ showCloseNav }) => showCloseNav,
  renderComponent(CloseNav)
)(({
  logout,
  userFullName
}) => (
    <Nav pullRight>
      <LinkContainer to={routes.publisherPortal.courseDashboard}>
        <NavItem eventKey={1}>Courses</NavItem>
      </LinkContainer>
      <LinkContainer to={routes.publisherPortal.publishedEventDashboard}>
        <NavItem eventKey={2}>Events</NavItem>
      </LinkContainer>
      <LinkContainer to={routes.publisherPortal.content}>
        <NavItem eventKey={3}>Content</NavItem>
      </LinkContainer>
      <NavDropdown id='nav-menu' eventKey={4} title={<NavDropdownTitle />} noCaret={true}>
        <MenuItem header>Logged in as {userFullName}</MenuItem>
        <MenuItem divider />
        <LinkContainer exact={true} to={routes.app.dashboard}>
          <MenuItem eventKey={4.1}>
            Go to User Portal
        </MenuItem>
        </LinkContainer>
        <MenuItem
          href={`mailto:support@thinkcaddie.com?subject=Caddie Support Request&cc=helpdesk@complii.com.au`}
          eventKey={4.2}>
          Support
      </MenuItem>
        <MenuItem eventKey={4.3} onClick={(e) => logout()}>
          Log out
      </MenuItem>
      </NavDropdown>
    </Nav>
  ));

const PublisherNav = ({
  showCloseNav,
  ...props
}) => (
    <Navbar
      className={classNames('navbar-signup', { 'publishers-close-nav': showCloseNav })}
      role='navigation'
      fluid={true}>
      <Navbar.Header>
        <Navbar.Toggle />
        <Navbar.Brand>
          <Link to={routes.publisherPortal.dashboard}>
            <img src={logo} alt='Caddie' />
            <span>for publishers</span>
          </Link>
        </Navbar.Brand>
      </Navbar.Header>
      <Navbar.Collapse>
        <MenuNav {...{ ...props, showCloseNav }} />
      </Navbar.Collapse>
    </Navbar >
  );

const mapStateToProps = (state) => ({
  user: currentUserSelector(state)
});

const mapDispatchToProps = (dispatch) => ({
  logout: bindActionCreators(sessionActions.session.logout, dispatch)
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ location: { pathname }, user }) => ({
    userFullName: fullName(user),
    showCloseNav: fp.includes(pathname, [
      routes.publisherPortal.contentDetails,
      routes.publisherPortal.completedContent,
      routes.publisherPortal.contentQuestion
    ])
  }))
)(PublisherNav);



// WEBPACK FOOTER //
// ./src/containers/partials/nav/publisher-nav.js